class HeroV2 extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.arrows = null;
    this.initAttempts = 0;
    this.pollTimeout = null;
    this.onSlideChange = this.onSlideChange.bind(this);
    this.tryInit = this.tryInit.bind(this);
  }

  connectedCallback() {
    this.arrows = this.querySelector("[data-arrows]");
    this.tryInit();
    this.initVideos();
  }

  disconnectedCallback() {
    if (this.pollTimeout) {
      clearTimeout(this.pollTimeout);
      this.pollTimeout = null;
    }
    if (this.swiper) {
      this.swiper.off("slideChange", this.onSlideChange);
    }
  }

  tryInit() {
    var swiperEl = this.querySelector(".swiper");
    if (!swiperEl || !swiperEl.swiper) {
      if (this.initAttempts < 20) {
        this.initAttempts++;
        this.pollTimeout = setTimeout(this.tryInit, 200);
      }
      return;
    }

    this.swiper = swiperEl.swiper;

    var self = this;

    this.querySelectorAll("[data-prev]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        if (self.swiper) self.swiper.slidePrev();
      });
    });

    this.querySelectorAll("[data-next]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        if (self.swiper) self.swiper.slideNext();
      });
    });

    // Listen for slide changes to toggle arrow visibility + color
    this.swiper.on("slideChange", this.onSlideChange);

    // Check initial slide
    this.updateArrows();
  }

  onSlideChange() {
    this.updateArrows();
  }

  initVideos() {
    var videos = this.querySelectorAll("video[autoplay]");
    videos.forEach(function (video) {
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function () {});
      }
    });
  }

  updateArrows() {
    if (!this.arrows || !this.swiper) return;

    var activeSlide = this.swiper.slides[this.swiper.activeIndex];
    if (!activeSlide) return;

    // Hide arrows if the active slide has cta_bottom_right
    if (activeSlide.getAttribute("data-hide-arrows") === "true") {
      this.arrows.style.display = "none";
    } else {
      this.arrows.style.display = "";
    }

    // Match arrow color to the active slide's text color
    var slideColor = activeSlide.style.color;
    if (slideColor) {
      this.arrows.style.color = slideColor;
    } else {
      this.arrows.style.color = "";
    }
  }
}

customElements.define("hero-v2", HeroV2);
